import * as React from 'react';
import { styled, alpha } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Divider from '@mui/material/Divider';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
    transformOrigin={{ vertical: 'top', horizontal: 'right' }}
    {...props}
  />
))(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color: theme.palette.mode === 'light' ? 'rgb(55, 65, 81)' : theme.palette.grey[300],
    boxShadow:
      'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
    '& .MuiMenu-list': {
      padding: '4px 0',
    },
    '& .MuiMenuItem-root': {
      '& .MuiSvgIcon-root': {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      '&:active': {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity,
        ),
      },
    },
  },
}));

/**
 * items = [
 *   { label: string, icon?: ReactNode, onClick: () => void, disabled?: boolean, dividerBefore?: boolean }
 * ]
 */
export default function SmartMenuButton({ label = 'Options', items = [], variant = 'contained', size = 'medium', color = 'primary', icon = null, width=null }) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  if (!items.length) return null;

  return (
    <div>
      <Button
        variant={variant}
        color={color}
        size={size}
        sx={{ justifyContent: 'space-between' }}
        style={{ width: width }}
        aria-controls={open ? 'smart-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        endIcon={<KeyboardArrowDownIcon />}
        startIcon={icon}
      >
        {label}
      </Button>

      <StyledMenu
        id="smart-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{ 'aria-labelledby': 'smart-menu-button' }}
      >
        {items.map((item, index) => (
          <React.Fragment key={item.label + index}>
            {item.dividerBefore && <Divider sx={{ my: 0.5 }} />}
            <MenuItem
              onClick={() => {
                item.onClick?.();
                handleClose();
              }}
              disabled={item.disabled}
              disableRipple
            >
              {item.icon && item.icon}
              {item.label}
            </MenuItem>
          </React.Fragment>
        ))}
      </StyledMenu>
    </div>
  );
}